export default "/images/be7db47c7bdf363bfb8fba3ca2d30849.avif";